/* eslint-disable camelcase */
import React from 'react';
import Spinner, { SpinnerSize, SpinnerTypes } from '../Spinner/Spinner';
import './LoadingBox.module.scss';

interface LoadingBoxPropsType {
  text?: string,
  text_placement?: 'top' | 'bottom',
  position?: 'relative' | 'absolute' | 'fixed',
  top_displacement?: string,
  size?: SpinnerSize,
  spinner_type?: SpinnerTypes,
  className?: string,
  ariaLabelSpinner?: string,
  textSize?: string,
  textWeight?: 'bold' | 'normal',
  spinner?: React.ReactNode,
}

function LoadingBox({
  text = 'Loading...',
  text_placement = 'top',
  position = 'relative',
  top_displacement = '-10%',
  size = SpinnerSize.lg,
  spinner_type = SpinnerTypes.RoundEven,
  className,
  ariaLabelSpinner,
  textSize = '29px',
  textWeight = 'bold',
  spinner,
}: LoadingBoxPropsType) {
  return (
    <div
      className={'loading-box' + (className ? ' ' + className : '')}
      style={{
        position
      }}
    >
      <div className='-inner-wrp'>
        <div
          className='-inner-wrp'
          style={{
            top: top_displacement
          }}
        >
          {text_placement === 'top' && <div className='-title' style={{ fontSize: textSize, fontWeight: textWeight }}>{text}</div>}

          {spinner ? spinner : (
            <Spinner
              className='-spinner'
              size={size}
              type={spinner_type}
              ariaLabel={ariaLabelSpinner}
            />
          )}

          {text_placement === 'bottom' && <div className='-title' style={{ fontSize: textSize, fontWeight: textWeight }}>{text}</div>}
        </div>
      </div>
    </div>
  );
}

export default LoadingBox;
